import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface ISignInFormData {
  email: string
  password: string
  remember: boolean
}

const SignInSchema: JSONSchemaType<ISignInFormData> = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: 'Por favor, insira um endereço de e-mail válido.',
    },
    password: {
      type: 'string',
      errorMessage: 'Este campo não pode estar em branco.',
    },
    remember: {
      type: 'boolean',
    },
  },
  required: ['email', 'password'],
  additionalProperties: false,
}

export default SignInSchema
